const pausePlayer = () => {
	if (window.jwplayer != null) {
		const jw = window.jwplayer();
		const playerContainer = document.querySelectorAll('.video-playerarea');

		if (playerContainer.length > 0 && jw && jw.getState() === 'playing') jw.pause();
	}
};

let scrollPosition = 0;

const body = document.querySelector('body');

const headerNav = document.querySelector('header.nav-menu');

// Helper functions: add & close menu
function addMenu() {
	// Keep track of position on page
	scrollPosition = window.scrollY;

	// Prevent body from scrolling behind nav menu
	body.style.overflow = 'hidden';
	body.style.position = 'fixed';
	body.style.width = '100%';

	// Ensure header nav is at the top of the nav menu modal.
	headerNav.style.position = 'fixed';
	headerNav.style.top = '0px';

	// Pause the video playback when user starts interacting with the menu
	pausePlayer();
}

function closeMenu() {
	body.style.removeProperty('overflow');
	body.style.removeProperty('position');
	body.style.removeProperty('width');

	// Return the header nav to its relative position in the page.
	headerNav.style.position = 'relative';
	headerNav.style.removeProperty('top');

	// Return page to proper position
	window.scrollTo(0, scrollPosition);
}

function toggleMainMenu() {
	body.classList.toggle('menu-open');

	if (body.classList.contains('menu-open')) {
		addMenu();
	} else {
		closeMenu();
	}
}

function focusOnSearchField() {
	const searchField = document.getElementById('search-field');

	if (searchField) {
		searchField.focus();
	}
}

function toggleSearchMenu() {
	body.classList.toggle('search-menu-open');

	if (body.classList.contains('search-menu-open')) {
		addMenu();
		focusOnSearchField();
	} else {
		closeMenu();
	}
}

function checkWindowResize() {
	const isOpenClass = 'menu-open';
	// 1024px - 1366px (iPad Landscape)
	const breakpoint = 1024;

	function handleResize() {
		if (window.innerWidth > breakpoint && body.classList.contains(isOpenClass)) {
			body.classList.remove(isOpenClass);
			closeMenu();
		}
	}
	// Check on page load
	handleResize();
	// Listen for window resize events
	window.addEventListener('resize', handleResize);
}

document.querySelector('.menu-toggle-button')
	.addEventListener('click', toggleMainMenu);

document.querySelector('.header-navbar-search')
	.addEventListener('click', toggleSearchMenu);

document.querySelector('.header-navbar-search-right')
	.addEventListener('click', toggleSearchMenu);

document.querySelector('#right-search-wrapper')
	.addEventListener('click', toggleSearchMenu);

document.querySelectorAll('a[target=_blank]').forEach((anchor) => {
	if (anchor.rel === '' || (!anchor.rel.includes('noopener') && !anchor.rel.includes('noreferrer'))) {
		anchor.rel = 'noopener noreferrer'; // eslint-disable-line no-param-reassign
	}
});

// Check window size to remove opened menu on desktop
checkWindowResize();
